module.exports = __webpack_public_path__ + "img/bd(6).3a03456b.webp";